module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/gemini-52705131c24b4ab7600328a7e71e36ef.svg";